import React from 'react';
import { useTranslation } from 'react-i18next';
import Duration from 'components/Duration';
import getFriendlyDurationParts from 'components/Duration/getFriendlyDurationParts';

// We don't need to add an extra screen-reader friendly
// aria-label as the regular readout is already readable.
// Adding the label leads to a double announcement.
import { jsx as _jsx } from "react/jsx-runtime";
var noLabel = function noLabel() {
  return null;
};
function FriendlyDuration(_ref) {
  var value = _ref.value,
    showSeconds = _ref.showSeconds;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Duration, {
    value: value,
    getLabel: noLabel,
    children: function children(duration) {
      return getFriendlyDurationParts(duration, t, {
        showSeconds: showSeconds
      });
    }
  });
}
export default FriendlyDuration;